import React from 'react';
import {Route, Routes} from "react-router-dom";
import routes from "../../Constants/routes";
import Login from "../Login";
import AliasContainer from "../../Containers/AliasContainer";
function AnonymousRoutes ({}) {
    return (
        <Routes>
            <Route path={routes.login} element={<Login/>}/>
            <Route path={"alias-validation-failed"} element={<AliasContainer/>}/>
            <Route path="*" element={<Login/>}/>
            <Route index element={<Login/>}/>
        </Routes>
    );
}

export default AnonymousRoutes;